import { data, tag } from '@blotoutio/edgetag-sdk-js'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { getPlacingForImpactTracker } from '@src/telemetry/utils/impact.utils'

import mixpanelCl from '../../../../../telemetry/integrations/mixpanel'

const ATTENTIVE_ORIGIN = 'https://creatives.attn.tv'

const ATTENTIVE_ACTIONS = {
  EMAIL_LEAD: 'EMAIL_LEAD',
  // @i18n-ignore
  MOBILE_LEAD: 'LEAD',
} as const

const handleAttentiveFrameMessages = (event: MessageEvent) => {
  // Security check: Validate origin to prevent spoofing
  if (event.origin !== ATTENTIVE_ORIGIN) {
    return
  }

  const { __attentive } = event.data || {}
  const {
    action,
    email,
    phone: mobileNumber,
    metadata: { Gender: gender } = {
      Gender: undefined,
    },
  } = __attentive || {}

  // Only process LEAD actions (EMAIL_LEAD or MOBILE_LEAD)
  if (!action?.includes('LEAD')) {
    return
  }

  // Build user data object from attentive data for Edge Tag
  const user: { email?: string; phone?: string; gender?: string } = {}

  if (email) {
    user.email = email
  }

  if (mobileNumber) {
    // Normalize phone number: remove all non-numeric characters
    user.phone = String(mobileNumber).replace(/[^0-9]/g, '')
  }

  if (gender) {
    // Convert gender to lowercase first letter
    user.gender = gender[0]?.toLowerCase() || ''
  }

  // Send user data to Edge Tag in real-time
  if (Object.keys(user).length > 0) {
    data(user)
    // eslint-disable-next-line i18next/no-literal-string
    tag('Lead')
  }

  // Track events for internal analytics (Mixpanel, Impact, etc.)
  // Note: Edge Tag Lead event is handled directly above, so we skip it here
  switch (action) {
    case ATTENTIVE_ACTIONS.EMAIL_LEAD:
      trackEvent(TELEMETRY_EVENT_NAMES.EMAIL_NEWSLETTER_SUBSCRIBE, {
        email,
        gender,
        // eslint-disable-next-line i18next/no-literal-string
        placing: getPlacingForImpactTracker('popup'),
        skipEdgeTag: true, // Skip Edge Tag as we already sent data/tag directly
      })
      mixpanelCl.identify({ email: email, isTentativeEmail: true })
      break
    case ATTENTIVE_ACTIONS.MOBILE_LEAD:
      trackEvent(TELEMETRY_EVENT_NAMES.SMS_NEWSLETTER_SUBSCRIBE, {
        mobileNumber,
        // @i18n-ignore
        // eslint-disable-next-line i18next/no-literal-string
        placing: 'popup',
      })
      break
  }
}

export { ATTENTIVE_ORIGIN, handleAttentiveFrameMessages }
